
//const
const APPLY_BIGDATA_QUOTA_UPDATE_DATA = "applyBigdataQuota/APPLY_BIGDATA_QUOTA_UPDATE_DATA"

//reducer
export const applyBigdataQuota = (state = {
  months:1,
},action) => {
  switch (action.type) {
    case APPLY_BIGDATA_QUOTA_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      }
    default:
      return state
  }
}
//actions
export const updateData = (data) => {
  return {
    type: APPLY_BIGDATA_QUOTA_UPDATE_DATA,
    data: data
  }
}
